import { defineComponent as _defineComponent } from 'vue'
import {
  PropType
} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TooltipListItem',
  props: {
  active: {
    required: true,
    type: Boolean as PropType<boolean>
  },
  title: {
    required: true,
    type: String as PropType<string>
  },
  tooltip: {
    required: false,
    type: String as PropType<string>,
    default: undefined
  },
  disabled: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  },
},
  emits: [
  'click',
],
  setup(__props, { emit: emits }) {






const onHandleOnClick = () => emits('click');


return { __sfc: true,emits, onHandleOnClick }
}

})